import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalEditMobileVerifyOne } from '../../../../redux/actions/partials/modals/modalEditMobileVerifyOne';
import { handleChangeDataModalEditMobileVerifyTwo } from '../../../../redux/actions/partials/modals/modalEditMobileVerifyTwo';
import { USERS_EDIT_MOBILE_SEND_OTP_1_POST, USERS_EDIT_MOBILE_SEND_OTP_2_POST } from '../../../../apis';
import useOutsideClick from './hooks/useOutsideClick'; 
import apiRequest from '../../../../utils/apiRequest';


const ModalEditMobileVerifyOne = (props) => {

	const dispatch = useDispatch();

	const { isMobile } = useSelector(state => state.general);
	const { isActive, mobile, newMobile, code, codeErr, timerTime} = useSelector(state => state.modalEditMobileVerifyOne);
	const { token } = useSelector(state => state.login);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);


	const handleClose = () => {
		dispatch(handleChangeDataModalEditMobileVerifyOne('mobile', ''));
		dispatch(handleChangeDataModalEditMobileVerifyOne('code', ''));
		dispatch(handleChangeDataModalEditMobileVerifyOne('codeErr', ''));
		dispatch(handleChangeDataModalEditMobileVerifyOne('timerTime', 0));

		dispatch(handleChangeDataModalEditMobileVerifyOne('isActive', false))
		setTimeout(() => {
            dispatch(handleChangeDataModalEditMobileVerifyOne('isOpen', false));
        }, 250);
    };    


  	const outerRef = useRef(null);
  	const centerBoxRef = useRef(null);
  	useOutsideClick(outerRef, centerBoxRef, handleClose, [ModalEditMobileVerifyOne]);



   	const timeoutRef = useRef(null);
	useEffect(() => {
	    if (timerTime > 0) {
	        timeoutRef.current = setTimeout(() => {
	            dispatch(handleChangeDataModalEditMobileVerifyOne('timerTime', timerTime - 1));
	        }, 1000);
	    } else {
	        clearTimeout(timeoutRef.current);
	    }

	    return () => clearTimeout(timeoutRef.current); // پاک‌سازی هنگام unmount یا تغییر
	}, [timerTime]);


	

    const handleChangeInputs = (event) => {
    	const {name, value} = event.target;
    	dispatch(handleChangeDataModalEditMobileVerifyOne(name, convertPersianArabicNumbersToEnglish(value)));
    };

    const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

	const handleSendCode = () => {
		apiRequest({
		    dispatch,
		    endpoint: USERS_EDIT_MOBILE_SEND_OTP_1_POST,
		    method: 'post',
		    data: { mobile: newMobile },
		    token: token,
		    onSuccess: (res) => {
		      	dispatch(handleChangeDataModalEditMobileVerifyOne('mobile', res.mobile));
            	dispatch(handleChangeDataModalEditMobileVerifyOne('timerTime', parseInt(res.timer_time)));
		    },
	  	});
    }


	const convertPersianArabicNumbersToEnglish = (str) => {
 		let persianArabicNumbers = {
	        '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
	        '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9',
	        '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
	        '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
	    };

	    return str.replace(/[۰-۹٠-٩]/g, (char) => persianArabicNumbers[char] || char);
 	};

	// const inputRefs = useRef({});
	// const handleOnInputFocus = (key) => {
 //        const currentInput = inputRefs.current[key];
 //        if (currentInput && errorTxt.length === 0) {
 //            dispatch(handleChangeInputLoginPage('inputClass', 'input-focused'));
 //            currentInput.classList.add("input-focused");
 //        }
 //    };



    const handleSubmitForm = (event) => {
    	event.preventDefault();

    	if(! isBackdropLoading) {
	    	if(code.length === 0)
	    		dispatch(handleChangeDataModalEditMobileVerifyOne('codeErr', 'لطفا این قسمت را خالی نگذارید!'));
	    	else if(code.length > 0 && code.length !== 4)
	    		dispatch(handleChangeDataModalEditMobileVerifyOne('codeErr', 'کد باید 4 رقم باشد'));
	    	else {
	    		dispatch(handleChangeDataModalEditMobileVerifyOne('codeErr', ''));


	    		apiRequest({
				    dispatch,
				    endpoint: USERS_EDIT_MOBILE_SEND_OTP_2_POST,
				    method: 'post',
				    data: { code },
				    token: token,
				    // successMessage: 'شماره فعلی شما تایید شد',
				    onSuccess: (res) => {
				      	dispatch(handleChangeDataModalEditMobileVerifyTwo('timerTime', res.timer_time));
	                	dispatch(handleChangeDataModalEditMobileVerifyTwo('isOpen', true));
						setTimeout(() => dispatch(handleChangeDataModalEditMobileVerifyTwo('isActive', true)), 250);

			    		handleClose();
				    },
			  	});

	    	}
    	}
    };

    return (

		<div ref={outerRef} className={`ReactModal__Overlay ${isActive ? 'ReactModal__Overlay--after-open' : ''}`} style={{position: 'fixed', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: '11'}}>
			<div ref={centerBoxRef} className="ReactModal__Content ReactModal__Content--after-open bg-neutral-000 absolute overflow-y-hidden rounded-medium styles_Modal__TsaRp" tabIndex="-1" role="dialog" aria-modal="true" style={ !isMobile ? {width: '460px'} : {width: '100%', maxHeight: '100vh', height: '100%'} }>
				<div className="flex flex-col h-full overflow-y-hidden styles_ModalLayout__y3Bs1" style={{paddingTop: '59px'}}>
					<div className="w-full z-1 bg-neutral-000 fixed top-0 right-0 px-5" width="420" height="58.59375">
						<div className="flex items-center border-complete-b-200">
							<div className="break-words py-3 grow">
								<div className="flex items-center grow">
									<p className="grow text-h5 text-neutral-900">
										<span className="relative">ویرایش شماره موبایل
										</span>
									</p>
								</div>
							</div>
							<div className="grow text-h5">
							</div>
							<div className="flex cursor-pointer" onClick={handleClose}>
								<svg data-test-id="close-modal-icon-button" style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#close"></use>
								</svg>
							</div>
						</div>
					</div>
					<div className="grow flex flex-col overflow-y-auto">
						<div className="grow flex flex-col styles_children__hHq5Q py-4 px-5">
							<div>
								<p className="text-body-2 text-neutral-700 mb-6 text-right w-full">کد ۴ رقمی به شماره‌ی  {toPersianDigits(mobile)} ارسال گردید
								</p>
								<form>
									<label className="FormComponentFrame_FormComponentFrame__PIUpy w-full FormComponentFrame_FormComponentFrame--normal__TQSOm">
										<div className="FormComponentFrame_FormComponentFrame__input-container__BHc4I px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 Input_InputWrapper__d_4kf">
											<div className="grow text-body-3">
												<input className="px-2 TextField_TextField__input__hFMFl text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--secondary__w_vGF text-subtitle w-full py-5 lg:py-2 rounded-medium text-center styles_codeInput__trackingOtp__mhz1j" type="number" name="code" maxLength="4" inputMode="numeric" value={code} onChange={handleChangeInputs} />
											</div>
										</div>
										<p className="text-body-2 text-hint-text-error">{codeErr}</p>
									</label>
								</form>
								<div className="bg-neutral-000 w-full px-5 py-3 lg:p-0 flex flex-col justify-between items-center gap-5 mt-4 fixed lg:relative bottom-0 left-0  lg:mt-7 lg:shadow-none">
									{ timerTime > 0 ?
										<p className="w-full mt-4 text-center text-body-2 py-2 text-neutral-700">
											<span className="w-10 inline-block mx-1 text-center">{toPersianDigits(timerTime)}</span> ثانیه مانده تا دریافت مجدد کد
										</p>
									:
										<button onClick={handleSendCode} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--small__4O6Vv styles_btn--text__W2jhM styles_btn--secondary__Warw0 rounded-medium mt-4 w-full">
											<div className="flex items-center justify-center relative grow">دریافت مجدد کد تایید</div>
										</button>
									}
									<button onClick={handleSubmitForm} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv  rounded-medium w-full mt-4" type="submit">
										<div className="flex items-center justify-center relative grow">ادامه
										</div>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>



        
    );
}

export default ModalEditMobileVerifyOne;
